import { createSlice } from '@reduxjs/toolkit'
import { AsyncData, DataStatus } from '@repo/ui/utils'

import { getCaseWorkers } from '@/store/case-workers/thunks'
import { CaseWorker } from '@/store/user'

interface State {
  caseWorkers: AsyncData<CaseWorker[]>
}

const initialState: State = {
  caseWorkers: [],
}

const slice = createSlice({
  name: 'caseWorkerList',
  initialState,
  reducers: {
    setCaseWorkers(state, action: { payload: CaseWorker[] }) {
      state.caseWorkers = action.payload
    },
    clear(state) {
      state.caseWorkers = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaseWorkers.pending, (state) => {
        state.caseWorkers = DataStatus.Loading
      })
      .addCase(getCaseWorkers.fulfilled, (state, action) => {
        state.caseWorkers = action.payload.caseWorkers
      })
      .addCase(getCaseWorkers.rejected, (state) => {
        state.caseWorkers = DataStatus.Error
      })
  },
})

export const { setCaseWorkers, clear } = slice.actions
export type { State as CaseWorkerListState }
export const caseWorkerListInitialState = initialState
export default slice.reducer
